import { memo, useEffect, useRef } from "react";

import { useLocationContext } from "@/src/contexts/LocationContext";
import useAjaxVisibility from "@Components/Hooks/useAjaxVisibility";
import { Loading } from "@Components/Loading";
import { Homepage } from "@Routes/HomepageLinks";
import * as stylex from "@stylexjs/stylex";

import type { IRoundList } from "../../common/RoundList";
import RoundList from "../../common/RoundList";
import type { ILocationInfo } from "../../location/LocationInfo";
import { LocationInfo } from "../../location/LocationInfo";

import * as css from "./ShoppingMallsSection.module.css";

export interface IShoppingMallsSection {
    roundTitleList: IRoundList;
    locationInfo: ILocationInfo;
}
const ShoppingMallsSection: React.FC<IShoppingMallsSection> = memo((props) => {
    const { location } = useLocationContext();

    const placeId = useRef(location.placeId);

    const { data, request, isLoading, refObj } = useAjaxVisibility({
        ajaxAction: Homepage.url,
        initialData: props.roundTitleList.initialData,
        rootMargin: "500px 0px",
    });

    useEffect(() => {
        if (placeId.current === location.placeId) return;

        placeId.current = location.placeId;
        request({ action: "MostPopularShoppingMalls" });
    }, [location.placeId]);

    return (
        <div className={css.shoppingMallsSectionComponent} ref={refObj}>
            <LocationInfo {...props.locationInfo} titleElement="h3" btnStyleX={styles.btnStyle} />
            {isLoading ? (
                <Loading />
            ) : (
                <RoundList
                    {...props.roundTitleList}
                    initialData={data}
                    carouselTelemetryCustom={{
                        eventName: "homepg-shpMallSwipe",
                        actionType: "Swipe",
                    }}
                />
            )}
        </div>
    );
});

const styles = stylex.create({
    btnStyle: {
        fontSize: "inherit",
    },
});

export default ShoppingMallsSection;
